import { Box, Radio, Typography } from "@mui/material";

import { Check, X } from "lucide-react";

interface Props {
  answer: string;
  setAnswer: (val: string) => void;
  showSolution: boolean;
  correctAnswer: string;
}

const TrueFalseInput = ({
  answer,
  setAnswer,
  showSolution,
  correctAnswer,
}: Props) => {
  const options = ["true", "false"];
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.25,
        mt: 2,
      }}
    >
      {options.map((option) => {
        const isSelected = answer === option;
        const isOptionCorrect =
          showSolution && option.toLowerCase() === correctAnswer.toLowerCase();
        const isOptionIncorrect =
          showSolution && isSelected && !isOptionCorrect;
        return (
          <Box
            key={option}
            onClick={() => !showSolution && setAnswer(option)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              px: 0.25,
              py: 0.125,
              cursor: showSolution ? "default" : "pointer",
            }}
          >
            <Radio
              checked={isSelected}
              onChange={() => !showSolution && setAnswer(option)}
              disabled={showSolution}
              value={option}
              sx={{
                color: "#2E5E47",
                p: 0.5,
                "&.Mui-checked": {
                  color: "#1E4A35",
                },
                "&.Mui-disabled": {
                  color: isOptionCorrect ? "#2E7D32" : "#8BA38E",
                },
              }}
            />
            <Typography
              variant="body1"
              sx={{ flex: 1, fontWeight: 600, color: "#1E4A35" }}
            >
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </Typography>

            {isOptionCorrect && <Check color="#2E7D32" style={{ marginLeft: 8 }} />}
            {isOptionIncorrect && <X color="#C62828" style={{ marginLeft: 8 }} />}
          </Box>
        );
      })}
    </Box>
  );
};

export default TrueFalseInput;
